// Adresse de la page web du jeu, que le QR code « Partager » encode : une configuration, pas l'adresse de la page ouverte. On mène
// toujours à la page officielle, où qu'on joue (appli installée, pré-production…), comme ZERO KAMI. Pour une autre adresse,
// construire ou lancer avec VITE_GAME_URL (ex. `VITE_GAME_URL=http://localhost:5173/ npm run dev`, ou une ligne dans un fichier
// .env). En développement, une adresse de loopback est remplacée par celle du réseau local (core/network.js#resolveShareUrl) pour
// scanner depuis un téléphone.
export const DEFAULT_GAME_URL = 'https://apps.0cog.com/fr/zero-maze/#share';

/** Adresse http(s) valide, sinon l'adresse par défaut. @param {unknown} value */
export function resolveGameUrl(value) {
  if (typeof value !== 'string' || value.trim() === '') return DEFAULT_GAME_URL;
  try {
    const url = new URL(value.trim());
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : DEFAULT_GAME_URL;
  } catch {
    return DEFAULT_GAME_URL;
  }
}

export const GAME_URL = resolveGameUrl(import.meta.env?.VITE_GAME_URL);
